export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/sw.js`;
    navigator.serviceWorker
      .register(swUrl, { scope: '/' })
      .catch(() => {
        // SW optional in dev if blocked; install may still work on some browsers.
      });
  });
}
